import React, {createContext, useContext, useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import translations from './translations';

const LanguageContext = createContext();

export const LanguageProvider = ({children}) => {
    const [language, setLanguage] = useState('en'); // Default language
    const navigate = useNavigate();
    const location = useLocation();

    const t = (key) => translations[language][key] || key;

    useEffect(() => {
        const [_, lang] = location.pathname.split('/');
        const validLanguages = ['en', 'uk'];

        if (validLanguages.includes(lang)) {
            setLanguage(lang);
        } else {
            navigate(`/en${location.pathname}`, {replace: true});
        }
    }, [location.pathname, navigate]);

    const changeLanguage = (lang) => {
        const currentPath = location.pathname.split('/').slice(2).join('/') || '';
        navigate(`/${lang}/${currentPath}`);
        setLanguage(lang);
    };

    return (
        <LanguageContext.Provider value={{language, changeLanguage, t}}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
